<template>
  <div>
    <div class="c-base-title-wrapper">
      <div class="c-base-title" id="cBaseTitle">
        <div :class="['c-container', { 'c-container--xl-max' : fullWidth }]">
          <div class="c-base-title__controls-top hidden xl:flex" v-if="hasSlots('controls-top')">
            <slot name="controls-top"></slot>
          </div>

          <div class="c-base-title__title-wrapper">
            <h2 class="c-title">
              <slot name="title"></slot>
              <span class="hidden xl:inline-flex items-center text-dark-grey-600 text-lg"><slot name="sub-title"></slot></span>
            </h2>

            <div class="c-base-title__controls-right" v-if="hasSlots('controls-right')">
              <slot name="controls-right"></slot>
            </div>
          </div>
        </div>
      </div>

      <div class="c-base-title__sub xl:hidden" v-if="hasSlots('controls-top') || hasSlots('sub-title')">
        <div class="c-base-title__controls-top">
          <slot name="controls-top"></slot>
        </div>
        <div class="c-base-title__sub-title xl:hidden"><slot name="sub-title"></slot></div>
      </div>

      <div class="c-base-title__copy" v-if="hasSlots('copy')">
        <div :class="['c-container', { 'c-container--xl-max' : fullWidth }]">
          <slot name="copy"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseTitle',
  props: {
    fullWidth: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    hasSlots (name) {
      return this.$scopedSlots[name] && (this.$scopedSlots[name]() || []).some(item => !item.isComment)
    }
  }
}
</script>
